$(document).ready(function() {

    $('.slide-section').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $('.slide-section-product').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.slide-section-product-thumb'
    });
    $('.slide-section-product-thumb').slick({
        asNavFor: '.slide-section-product',
        focusOnSelect: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });
    // Next section removed by Bob 20/11/2020
    /*
  	$('.product-single__thumbnails').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
	  focusOnSelect: true
    });
    */



    $(".site-header .inner .js-mobile-nav-toggle").on("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        jQuery("body").toggleClass("menu-open");
    });

    $(".mobile-nav-wrapper .mobile-nav .close-btn").on("click", function(event) {
        jQuery("body").removeClass("menu-open");
        jQuery(".mobile-nav-wrapper").removeClass("js-menu--is-open");
    });

    $('.ft-btn').click(function() {
        var Data_image = $(this).attr('data-items');
        $(this).addClass('selected').siblings().removeClass('selected');

        $(this).parents('.featured-box').find('.' + Data_image).show().siblings().hide();
    });

    $('.image-btn-tag').click(function() {
        var Data_image = $(this).attr('data-image');
        $(this).addClass('selected').siblings().removeClass('selected');

        $('.' + Data_image).addClass('selected').siblings().removeClass('selected');
    });

    if ($(window).width() < 750) {
        $(".site-footer__content .site-footer__item .site-footer__item-inner").on("click", function(event) {
            jQuery(this).toggleClass("active");
        });

    }

    $(".menu-section .page-menu .mobile-arrow").on("click", function(event) {
        jQuery(this).parent('.page-menu').toggleClass('active');
    });


    setTimeout(function() {
        $(".cart__buttons-container:has(.sd_coupon.listpromo)").addClass("promo-code");
        var text = $('a.btn.sd_partialpayment.sd_cartbtn').text();

    }, 1500);

    /*
  $('.product').TreeSixtyImageRotate({
                totalFrames: 162,
                endFrame: 162,
                currentFrame: 0,
                extension: ".png",
                imagesFolder: "https://cdn.shopify.com/s/files/1/0405/9889/6792/files/",
                smallWidth: 960,
                smallHeight: 480,
                largeWidth: 800,
                largeHeight: 800,
                imagePlaceholderClass: "images-placeholder"
            }).initTreeSixty();

  */
    var number = $('ul.list-view-items li.list-view-item').length;
    console.log(number);
    $('h1.h2 span.count').text(number);

});


$('.social-icons__item a').attr('target', '_blank');

$('.cart-section p.cart__remove a').click(function() {
    setTimeout(function() {
        location.reload(true);
    }, 1000);

});
